export const PostTypes: {[key: string]: {width: number; height: number; key: string}} = {
  instagramSquare: {
    width: 1080,
    height: 1080,
    key: 'instagramSquare',
  },
  instagramStory: {
    width: 1080,
    height: 1920,
    key: 'instagramStory',
  },
  instagramPortrait: {
    width: 1080,
    height: 1350,
    key: 'instagramPortrait',
  },
  pubTV: {
    width: 1920,
    height: 1080,
    key: 'pubTV',
  },
  facebookTimeline: {
    width: 1200,
    height: 630,
    key: 'facebookTimeline',
  },
};
